import AddPnmModalContainer from './AddPnmModalContainer';

export default AddPnmModalContainer;
